"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
/* eslint-disable react-hooks/exhaustive-deps */

const useTownStationFromURL = _ref => {
  let {
    stationStops
  } = _ref;
  const [stationTownObj, setStationTownObj] = (0, _react.useState)({});
  const [pagenameFromHash, setPagenameFromHash] = (0, _react.useState)("");
  const location = (0, _reactRouterDom.useLocation)();
  (0, _react.useEffect)(() => {
    // read url pagename

    const {
      hash
    } = location;
    const hashUrlPagename = hash === null || hash === void 0 ? void 0 : hash.substring(1);
    if (hashUrlPagename) {
      setPagenameFromHash(hashUrlPagename);
    }
  }, []);
  (0, _react.useEffect)(() => {
    if (pagenameFromHash) {
      const foundFacility = stationStops === null || stationStops === void 0 ? void 0 : stationStops.find(station => station.pagename === pagenameFromHash);
      const {
        id,
        city,
        pagename,
        title
      } = foundFacility || {};
      if (city && title) {
        setStationTownObj({
          id,
          pagename,
          station: title,
          town: city
        });
      }
    }
  }, [pagenameFromHash, stationStops]);
  return stationTownObj;
};
var _default = exports.default = useTownStationFromURL;